import { Options, Vue } from "vue-class-component"

import type { RouteLocationRaw } from "vue-router"

@Options({
  name: "ShowAlertUnsavedChanges"
})
export class ShowAlertUnsavedChanges extends Vue {
  unsavedChanges = false
  goTo: RouteLocationRaw | ""
  continueUnsave = false
  cancelUnsave = false
  onGoingToLeave = false
  disabledBeforeUnload = false
  unsavedChangesId = "unsaved-changes"
  goBack = false
  created() {
    window.addEventListener("beforeunload", this.beforeUnloadListener)
  }

  beforeUnloadListener(event) {
    if (this.disabledBeforeUnload) return
    this.onBeforeShowModal()
    if (this.unsavedChanges) {
      event.preventDefault()
      event.returnValue = ""
      return ""
    }
    return null
  }

  onBeforeRouteUpdate(to, from, next, goBack = false) {
    // Overlays such as Fancybox may remove a synthetic same-URL history entry on close.
    // Since the user remains on the same route, this must not be treated as navigation away.
    if (to.fullPath === from.fullPath) {
      next()
      return
    }

    if (this.unsavedChanges) {
      this.onGoingToLeave = true
      this.showUnsavedChangesModal()
      this.goBack = goBack
      this.goTo = to
      next(false)
    } else {
      next()
    }
  }

  showUnsavedChangesModal() {
    this.$modal.show(this.unsavedChangesId)
  }

  onBeforeShowModal() {
    return
  }

  beforeUnmount() {
    window.removeEventListener("beforeunload", this.beforeUnloadListener)
  }

  goNext() {
    this.$modal.hide(this.unsavedChangesId)
    this.unsavedChanges = false
    this.continueUnsave = !this.continueUnsave
    this.onGoingToLeave = false
    this.onContinueUnsave()
    if (!this.goTo) return false
    this.$nextTick(() => {
      if (this.goBack) {
        this.goBack = false
        return this.$router.go(-1)
      }
      this.$router.push(this.goTo)
    })
  }

  onClosedUnsavedModal() {
    this.cancelUnsave = !this.cancelUnsave
    this.onGoingToLeave = false
  }

  onContinueUnsave() {
    //
  }
}
